var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelegram = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_57)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300 150C300 232.843 232.843 300 150 300C67.1574 300 0 232.843 0 150C0 67.1574 67.1574 0 150 0C232.843 0 300 67.1574 300 150ZM163.439 107.081C137.428 117.919 62.4282 148.699 62.4282 148.699C44.6538 155.636 55.0578 162.139 55.0578 162.139C55.0578 162.139 70.2312 167.341 83.2374 171.242C96.243 175.144 103.18 170.809 103.18 170.809C103.18 170.809 133.526 150.867 164.306 129.624C185.983 114.884 180.781 127.023 175.578 132.226C164.306 143.497 145.665 161.272 130.058 175.578C123.122 181.648 126.59 186.85 129.625 189.451C138.451 196.919 159.238 210.501 168.676 216.667C171.291 218.376 173.034 219.515 173.411 219.797C175.578 221.532 187.717 229.335 195.087 227.601C202.457 225.867 203.324 215.896 203.324 215.896C203.324 215.896 208.96 180.347 214.162 147.832C215.126 141.448 216.089 135.198 216.988 129.37C219.323 114.223 221.219 101.926 221.532 97.5432C222.833 82.8036 207.226 88.8726 207.226 88.8726C207.226 88.8726 173.411 102.746 163.439 107.081Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telegram.c6713f411e551b6cec19718cb3e198d9.svg";